import { Component, Vue, Watch } from "vue-property-decorator";
import { productStore } from "@/store/ProductModule";
import { Variant, TranslationModel, ProductModel, MortarCalculatorModel, ProductsCannotBeCalculated, CarbonSavingsModel } from "../models/product";
import { IncludedProducts, QuantityCalculationResultModel } from "../models/QuanityCalculatorCast";
import calculatorService from "../services/CalculatorService";
import { CalculatorTypes } from "../enums/CalculatorTypes";
import CarbonSavingsCalculation from "./ProductPage/CarbonSavingsCalculation";
import { EventBus } from "@/events";

@Component({
    components: {
        CarbonSavingsCalculation,
    }
})
export default class QuantityCalculatorMortarProduct extends Vue {
    protected vm!: any;
    protected translations: TranslationModel;
    protected mortarCalculatorModel: MortarCalculatorModel = {mortarProductsList: [], buildingOptions: []};
    protected selectedBuildingOption: string = "0";
    protected variantsCanBeCalculated: Variant[] = [];
    protected productsCannotBeCalculated: ProductsCannotBeCalculated[] = [];
    protected results: QuantityCalculationResultModel[] = [];
    protected buildingOptionName: string = "";
    protected hideVariantOptions: boolean = false;
    protected selectedVariantId: string = "0";
    protected totalYta: number = NaN;
    protected calculatedSack: number = 0;
    protected selectedResult: QuantityCalculationResultModel = calculatorService.GetDefaultQuantityCalculatorResultModel();
    protected isPartOfSection: boolean = false;
    protected noProductSelectedHeader: string = "";
    protected noProductSelectedText: string = "";
    protected selectedProductId: string = "";
    protected products: IncludedProducts[] = [];
    protected initialProductData: IncludedProducts[] = [];
    protected isMobile: boolean = false;
    protected title: string = "";
    protected isiframe: boolean = false;

    constructor() {
        super();
        this.translations = window.__finja.translations as TranslationModel;
    }

    protected created() {
        this.isPartOfSection = this.$attrs.section === "true";
        this.noProductSelectedHeader = this.$attrs.noproductselectedheader;
        this.noProductSelectedText = this.$attrs.noproductselectedtext;
        this.products = this.$attrs.includedproducts
            ? JSON.parse(this.$attrs.includedproducts)
            : null;
        this.initialProductData = this.products;
        this.isMobile = this.$attrs.ismobile === "true";
        this.title = this.$attrs.title;
        if (!this.isPartOfSection) {
            this.mortarCalculatorModel = this.product.mortarCalculatorViewModel as MortarCalculatorModel;
        } else {
            this.mortarCalculatorModel = {buildingOptions : (JSON.parse(this.$attrs.buildingoptions)), mortarProductsList: []};
        }
        this.hideVariantOptions = false;

        if (!this.isPartOfSection && this.product.buildingOptionFromRequest && this.product.buildingOptionFromRequest !== "0"
        && this.product.buildingOptionFromRequest !== "") {
            this.selectedBuildingOption = this.product.buildingOptionFromRequest;
            this.loadVariantOptions();
        }
        this.isiframe = this.$attrs.isiframe === "true";
    }

    protected mounted() {
        EventBus.$on("selectedECOvariant", (carbonSavingsModel: CarbonSavingsModel) => {
            this.products.map(x => {
                if (x.carbonSavings.currentVariantId === carbonSavingsModel.ecoVariantId) {
                    this.selectedProductId = x.ArticleNumber;
                    this.calculateQuantity();
                }
            });
        });
    }

    get product(): ProductModel {
        return productStore.product;
    }

    get selectedProductName(): string {
        const products = this.products.filter(
            x => x.ArticleNumber === this.selectedProductId
        );
        return products !== undefined && products.length > 0
            ? products[0].Name
            : "";
    }

    get selectedProductUrl(): string {
        return calculatorService.GetSelectedProductUrl(this.products, this.selectedProductId);
    }

    get variant(): Variant {
        return calculatorService.GetVariant(this.selectedProductId, this.variants, CalculatorTypes.Mortar);
    }

    get variants(): Variant[] {
        return calculatorService.GetVariants(this.selectedProductId, this.products);
    }

    protected changeProduct() {
        this.results = [];
        this.selectedResult = calculatorService.GetDefaultQuantityCalculatorResultModel();
        this.loadVariantOptions(true);
        this.calculateQuantity();
    }

    protected loadVariantOptions(changedProduct: boolean = false) {
        this.selectedResult = calculatorService.GetDefaultQuantityCalculatorResultModel();
        this.results = [];

        if (this.isPartOfSection && changedProduct !== true) {
            this.selectedProductId = "";
            this.calculatedSack = 0;
            this.selectedVariantId = "0";
            this.loadProductsBasedOnVariantOption();
        }
        if (this.isPartOfSection && this.selectedProductId !== "") {
            const selectedProductData = this.products.filter(x => x.ArticleNumber === this.selectedProductId);
            if (selectedProductData) {
                const tempOptions = this.mortarCalculatorModel.buildingOptions;
                this.mortarCalculatorModel = selectedProductData[0].MortarModel as MortarCalculatorModel;
                this.mortarCalculatorModel.buildingOptions = tempOptions;
            }
        }
        if (this.isPartOfSection && this.selectedProductId === "") {
            this.productsCannotBeCalculated = [];
            this.variantsCanBeCalculated = [];
            this.products.map(x => {
                x.MortarModel.mortarProductsList.filter(option => option.buildingOption === this.selectedBuildingOption).map(y => {
                    y.variantsCanBeCalculated.map(z => {
                        if (this.variantsCanBeCalculated.filter(a => a.variantId === z.variantId).length <= 0) {
                            this.variantsCanBeCalculated.push(z);
                        }
                    });
                });
            });
        } else {
            const selectedProductList = this.mortarCalculatorModel && this.mortarCalculatorModel.mortarProductsList.filter(x => x.buildingOption === this.selectedBuildingOption);
            const variantsCanBeCalculatedExists = selectedProductList[0].variantsCanBeCalculated && selectedProductList[0].variantsCanBeCalculated.length > 0;
            const productsCannotBeCalculatedExists = selectedProductList[0].productsCannotBeCalculated && selectedProductList[0].productsCannotBeCalculated.length > 0;

            if (selectedProductList && selectedProductList.length > 0) {
                if (variantsCanBeCalculatedExists || productsCannotBeCalculatedExists) {
                    this.variantsCanBeCalculated = selectedProductList[0].variantsCanBeCalculated;
                    this.productsCannotBeCalculated = selectedProductList[0].productsCannotBeCalculated;

                    this.buildingOptionName = this.mortarCalculatorModel.buildingOptions.filter(x => x.id === this.selectedBuildingOption)[0].name;
                    if (this.variantsCanBeCalculated && this.productsCannotBeCalculated && this.variantsCanBeCalculated.length === 0
                        && this.productsCannotBeCalculated.length === 0) {
                        this.hideVariantOptions = true;
                    } else {
                        this.hideVariantOptions = false;
                    }
                }
            } else if (!this.isPartOfSection) {
                this.hideVariantOptions = true;
            }
        }
    }

    protected loadProductsBasedOnVariantOption() {
        const tempProductData: IncludedProducts[] = [];
        this.initialProductData.map(x => {
            x.MortarModel.mortarProductsList.filter(option => option.buildingOption === this.selectedBuildingOption).map(y => {
                y.variantsCanBeCalculated.map(z => {
                    if (this.variantsCanBeCalculated.filter(a => a.variantId === z.variantId).length > 0) {
                        if (tempProductData.filter(item => item.ArticleNumber === x.ArticleNumber).length <= 0) {
                            tempProductData.push(x);
                        }
                    }
                });

                if (this.selectedVariantId === "0" && y.variantsCanBeCalculated.length > 0) {
                    tempProductData.push(x);
                }
            });
        });

        if (tempProductData.length > 0) {
            this.products = tempProductData;
        }
    }

    protected GetCarbonSavingsModel() {
        return calculatorService.GetCarbonSavingsModel(this.products, this.selectedProductId);
    }

    protected calculateQuantity() {
        if (this.isPartOfSection && this.selectedProductId === "") {
            this.loadProductsBasedOnVariantOption();
        } else {
            this.results = [];
            this.calculatedSack = 0;
            this.variants.map(x => {
                if (x.itemConsumptionCalculatorMortar && this.selectedVariantId && this.totalYta > 0) {
                    const selectedVariant = this.variantsCanBeCalculated.filter(y => y.variantId === this.selectedVariantId);
                    const selectedVariantJoint = selectedVariant ?
                        (selectedVariant[0].itemConsumptionFullJoint > 0 ? selectedVariant[0].itemConsumptionFullJoint : selectedVariant[0].itemConsumptionStringJoint) : 0;

                    const sack = Math.ceil((selectedVariantJoint * this.totalYta) / x.itemPrimaryPackagingWeight);

                    this.results.push({
                        variantId: x.variantId,
                        sack,
                        itemPackagingWeight: x.itemPrimaryPackagingWeight,
                        selected: (x.variantId === this.variant.variantId).toString(),
                        volume: 0,
                        selectedShape: "",
                        yta: NaN,
                        layerThickness: NaN,
                        itemMaterialConsumption: NaN,
                        variantJoint: selectedVariant[0].itemConsumptionFullJoint > 0 ? "full" : "string",
                        width: NaN,
                        length: NaN,
                        depth: NaN,
                        variantSystemId: x.variantSystemId,
                    });
                }
            });

            if (this.results.length > 0) {
                const selectedVariant = this.results.filter(x => x.variantId === this.variant.variantId)[0];
                this.calculatedSack = selectedVariant.sack;
                this.selectedResult = selectedVariant;
                if (selectedVariant != null) {
                    productStore.dispatchQuantity(selectedVariant.sack);
                }
                calculatorService.storeSession("mortarquantity", this.results);
                const tempResults: QuantityCalculationResultModel[] = [];
                this.results.map(x => {
                    if (tempResults.filter(a => a.itemPackagingWeight === x.itemPackagingWeight).length <= 0) {
                        tempResults.push(x);
                    }
                });
                this.results = tempResults;

                if (this.GetCarbonSavingsModel()) {
                    calculatorService.storeSessionQuantity("carbonsavingsproductquantity", this.calculatedSack);
                }
            } else {
                this.calculatedSack = 0;
                this.selectedResult = calculatorService.GetDefaultQuantityCalculatorResultModel();
            }
        }
    }

    protected close() {
        if (this.selectedResult.sack > 0) {
            productStore.dispatchQuantity(this.calculatedSack);
        }
        this.$emit("close", true);
        const quantityInput = document.getElementById(
            "variant-selector-quantity"
        );
        if (quantityInput) {
            quantityInput.scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "nearest"
            });
        }
    }
}
